import { observable } from "mobx";
import RefundApprovalRejectionReason from "./refundApprovalRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundApprovalPermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: RefundApprovalRejectionReason;
}
